import { render } from "./Tender.vue?vue&type=template&id=1af99360"
import script from "./Tender.vue?vue&type=script&lang=js"
export * from "./Tender.vue?vue&type=script&lang=js"
script.render = render

export default script